import { Injectable, TemplateRef, ViewContainerRef } from "@angular/core"
import { Overlay, OverlayContainer, OverlayRef } from "@angular/cdk/overlay"
import { TemplatePortal } from "@angular/cdk/portal"

export interface MobileContextSheetOverlayHandle {
    overlayRef: OverlayRef
    dispose: () => void
}

@Injectable({ providedIn: "root" })
export class MobileContextSheetOverlayService {
    private activeSheets = 0

    constructor(
        private overlay: Overlay,
        private overlayContainer: OverlayContainer
    ) {}

    public open(
        template: TemplateRef<unknown>,
        viewContainerRef: ViewContainerRef
    ): MobileContextSheetOverlayHandle {
        const scrollStrategy =
            this.activeSheets === 0
                ? this.overlay.scrollStrategies.block()
                : this.overlay.scrollStrategies.noop()
        const overlayRef = this.overlay.create({
            hasBackdrop: true,
            backdropClass: "mobile-context-sheet-backdrop",
            panelClass: "mobile-context-sheet-pane",
            positionStrategy: this.overlay
                .position()
                .global()
                .left("0")
                .right("0")
                .bottom("0"),
            scrollStrategy,
            disposeOnNavigation: true,
            width: "100vw",
        })

        this.activeSheets += 1
        this.overlayContainer
            .getContainerElement()
            .classList.add("mobile-context-sheet-overlay-active")
        document.body.classList.add("mobile-context-sheet-open")

        overlayRef.attach(new TemplatePortal(template, viewContainerRef))

        let disposed = false
        const dispose = () => {
            if (disposed) {
                return
            }

            disposed = true
            overlayRef.dispose()
            this.activeSheets = Math.max(0, this.activeSheets - 1)

            if (this.activeSheets === 0) {
                this.overlayContainer
                    .getContainerElement()
                    .classList.remove("mobile-context-sheet-overlay-active")
                document.body.classList.remove("mobile-context-sheet-open")
            }
        }

        return { overlayRef, dispose }
    }
}
